module.exports = __webpack_public_path__ + "static/img/wechat.146542f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dataDownload/downloadDetail/wechat.png
// module id = 675
// module chunks = 12